import React from 'react';
import { useMiniApps } from '../../hooks/useMiniApps';
import { useMiniAppModal } from '../../hooks/useMiniAppModal';
import { MINI_APP_ICONS, type MiniAppId } from '../../utils/miniAppsIcons';

interface MiniAppButtonProps {
  app: {
    id: MiniAppId;
    label: string;
    buttonVisible: boolean;
  };
}

export function MiniAppButton({ app }: MiniAppButtonProps) {
  const { buttonColors } = useMiniApps();
  const { openModal } = useMiniAppModal();
  const AppIcon = MINI_APP_ICONS[app.id];

  const handleClick = () => {
    // Ouvrir la modal sans aucun filtre (important pour différencier 
    // une ouverture normale d'une ouverture via détection de produits)
    const emptyFilters = app.id === 'products' ? { products: { mentionedIds: [] } } : undefined;
    openModal(app.id, emptyFilters);
    console.log('Mini-app ouverte via bouton:', app.id);
  };

  if (!app.buttonVisible) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      style={{
        background: `linear-gradient(315deg, ${buttonColors.endColor}, ${buttonColors.startColor})`,
        color: buttonColors.textColor || '#FFFFFF',
      }}
      className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm transition-all hover:opacity-90 shadow-[0_2px_8px_rgba(0,0,0,0.1)] hover:shadow-[0_4px_12px_rgba(0,0,0,0.15)]"
    >
      <AppIcon className="w-4 h-4" />
      <span>{app.label}</span>
    </button>
  );
}